export enum DecisionsTableColumnDisplayName {
  Date = 'Date',
  StrategyName = 'Strategy Name',
  DecisionName = 'Decision Name',
  Source = 'Source',
  ExecutionTime = 'Execution Time',
  Result = 'Result',
}
